var map = {
	"../avatar/avatar.module": [
		"./src/app/pages/avatar/avatar.module.ts",
		"avatar-avatar-module"
	],
	"../input/input.module": [
		"./src/app/pages/input/input.module.ts",
		"input-input-module"
	],
	"../list-sliding/list-sliding.module": [
		"./src/app/pages/list-sliding/list-sliding.module.ts",
		"list-sliding-list-sliding-module"
	],
	"./pages/action-sheet/action-sheet.module": [
		"./src/app/pages/action-sheet/action-sheet.module.ts",
		"pages-action-sheet-action-sheet-module"
	],
	"./pages/alert/alert.module": [
		"./src/app/pages/alert/alert.module.ts",
		"pages-alert-alert-module"
	],
	"./pages/avatar/avatar.module": [
		"./src/app/pages/avatar/avatar.module.ts",
		"avatar-avatar-module"
	],
	"./pages/buttons/buttons.module": [
		"./src/app/pages/buttons/buttons.module.ts",
		"pages-buttons-buttons-module"
	],
	"./pages/card/card.module": [
		"./src/app/pages/card/card.module.ts",
		"pages-card-card-module"
	],
	"./pages/check/check.module": [
		"./src/app/pages/check/check.module.ts",
		"pages-check-check-module"
	],
	"./pages/date-time/date-time.module": [
		"./src/app/pages/date-time/date-time.module.ts",
		"pages-date-time-date-time-module"
	],
	"./pages/fab/fab.module": [
		"./src/app/pages/fab/fab.module.ts",
		"pages-fab-fab-module"
	],
	"./pages/grid/grid.module": [
		"./src/app/pages/grid/grid.module.ts",
		"pages-grid-grid-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"pages-home-home-module"
	],
	"./pages/infinite-scroll/infinite-scroll.module": [
		"./src/app/pages/infinite-scroll/infinite-scroll.module.ts",
		"pages-infinite-scroll-infinite-scroll-module"
	],
	"./pages/input/input.module": [
		"./src/app/pages/input/input.module.ts",
		"input-input-module"
	],
	"./pages/list-reorder/list-reorder.module": [
		"./src/app/pages/list-reorder/list-reorder.module.ts",
		"pages-list-reorder-list-reorder-module"
	],
	"./pages/list-sliding/list-sliding.module": [
		"./src/app/pages/list-sliding/list-sliding.module.ts",
		"list-sliding-list-sliding-module"
	],
	"./pages/loading/loading.module": [
		"./src/app/pages/loading/loading.module.ts",
		"pages-loading-loading-module"
	],
	"./pages/modal-info/modal-info.module": [
		"./src/app/pages/modal-info/modal-info.module.ts",
		"common"
	],
	"./pages/modal/modal.module": [
		"./src/app/pages/modal/modal.module.ts",
		"common",
		"pages-modal-modal-module"
	],
	"./pages/popover/popover.module": [
		"./src/app/pages/popover/popover.module.ts",
		"pages-popover-popover-module"
	],
	"./pages/progress-bar/progress-bar.module": [
		"./src/app/pages/progress-bar/progress-bar.module.ts",
		"pages-progress-bar-progress-bar-module"
	],
	"./pages/refresher/refresher.module": [
		"./src/app/pages/refresher/refresher.module.ts",
		"pages-refresher-refresher-module"
	],
	"./pages/searchbar/searchbar.module": [
		"./src/app/pages/searchbar/searchbar.module.ts",
		"pages-searchbar-searchbar-module"
	],
	"./pages/segment/segment.module": [
		"./src/app/pages/segment/segment.module.ts",
		"pages-segment-segment-module"
	],
	"./pages/slides/slides.module": [
		"./src/app/pages/slides/slides.module.ts",
		"pages-slides-slides-module"
	],
	"./pages/tabs/tabs.module": [
		"./src/app/pages/tabs/tabs.module.ts",
		"pages-tabs-tabs-module"
	],
	"./pages/toast/toast.module": [
		"./src/app/pages/toast/toast.module.ts",
		"pages-toast-toast-module"
	],
	"./pages/toggle/toggle.module": [
		"./src/app/pages/toggle/toggle.module.ts",
		"pages-toggle-toggle-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;